import { v4 as uuidv4 } from 'uuid'

import { CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME } from '@constants'

import { ObjectDataRecord } from '../../../types'

// TODO: Костыль. Нужно переходить на курсорную пагинацию
export const getTransformResponse = (data: ObjectDataRecord[]) =>
  data.map(object => ({
    ...object,
    _id: object._id ? object._id : object.id,
    [CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME]:
      object[CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME] ?? uuidv4(),
  }))
